export interface sideBannerItemType {
  ExtensionData?: any;
  Description: string;
  EndDate: string;
  FileName: string;
  IsActive: boolean;
  ItemName: string;
  LangId: number;
  Link: string;
  PositionId: number;
  SideBannerId: number;
  StartDate: string;
  Title: string;
}
// BannerItem modeli
export class BannerItemModel {
  ExtensionData: object;
  Description: string;
  EndDate: string;
  FileName: string;
  IsActive: boolean;
  ItemName: string;
  LangId: number;
  Link: string;
  PositionId: number;
  SideBannerId: number;
  StartDate: string;
  Title: string;

  constructor(data: sideBannerItemType) {
    this.ExtensionData = data.ExtensionData || {};
    this.Description = data.Description || '';
    this.EndDate = data.EndDate;
    this.FileName = data.FileName;
    this.IsActive = data.IsActive;
    this.ItemName = data.ItemName;
    this.LangId = data.LangId;
    this.Link = data.Link;
    this.PositionId = data.PositionId;
    this.SideBannerId = data.SideBannerId;
    this.StartDate = data.StartDate;
    this.Title = data.Title || '';
  }
}

export class BannerItemListModel {
  sideBannerList: BannerItemModel[] = [];

  constructor(data: sideBannerItemType[], _sblocationid?: number) {
    if (data && Array.isArray(data) && data.length > 0) {
      const filteredData = data.filter(y => y.PositionId === _sblocationid);
      // Title alanına göre küçükten büyüğe sıralama yapılıyor
      const sortedData = filteredData.sort((a, b) => {
        if (a.Title < b.Title) {
          return -1;
        }
        if (a.Title > b.Title) {
          return 1;
        }
        return 0;
      });
      this.sideBannerList = sortedData.map(i => new BannerItemModel(i));
    }
  }
}
